// extracted by mini-css-extract-plugin
export default {"container":"Carousel_container__fR1EA","wrapper":"Carousel_wrapper__KaYPg","item":"Carousel_item__3+igJ"};